import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const styles = {
    header: {
        position: 'absolute',
        right: 0,
        left: 0,
        top: 0,
        height: Theme.appHeaderHeight,
        backgroundColor: Theme.appHeaderBackgroundColor
    }
};

export default StyleSheet.create(styles);
